import styled from "styled-components";

const MainContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  margin-top: 8%;

  flex-direction: column;
  align-content: center;

  justify-content: center;
`;

const SmileyContainer = styled.img`
  width: 25rem;
  height: auto;
  align-self: center;
  margin: 3rem;
`;

const Text = styled.h1`
  font-size: 4em;
  font-weight: 400;
  align-self: center;
`;

const Text2 = styled.h1`
  font-size: 5em;
  font-weight: 400;
  align-self: center;
`;

function ThisIsTheEnd() {
  const smiley = "/images/WiMuleHaveANiceDay.svg";

  return (
    <MainContainer>
      <Text>SITE IS DOWN</Text>
      <Text>BY ORDER OF MANAGEMENT</Text>
      <SmileyContainer src={smiley} />
      <Text2>HAVE A NICE DAY</Text2>
    </MainContainer>
  );
}

export default ThisIsTheEnd;
